"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ListItemSecondaryAction_1 = __importDefault(require("@mui/material/ListItemSecondaryAction"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var minutesToReadable = function (t) {
    var hours = Math.floor(t / 60);
    var hourText = hours > 1 ? 'hours' : 'hour';
    var minutes = t % 60;
    var timeText = '';
    if (hours > 0) {
        timeText = "".concat(hours, " ").concat(hourText, " ");
    }
    if (minutes > 0) {
        timeText = "".concat(timeText, " ").concat(minutes, " minutes");
    }
    return timeText;
};
function AmenityLI(prop) {
    var setAmenityToDelete = prop.setAmenityToDelete, setSelectedAmenity = prop.setSelectedAmenity, setDeleteOpen = prop.setDeleteOpen, setTimeLimit = prop.setTimeLimit, setValue = prop.setValue, setVisible = prop.setVisible, setVaccine = prop.setVaccine, setAmenityOpen = prop.setAmenityOpen, children = prop.children;
    var amenity = children;
    var icon = amenity.vaccine ? '💉' : '🦠';
    var primary = "".concat(icon, " ").concat(amenity.name);
    var secondary = minutesToReadable(amenity.timeLimit);
    function deleteAmenity(theAmenity) {
        setAmenityToDelete(theAmenity.id);
        setSelectedAmenity(theAmenity);
        setDeleteOpen(true);
    }
    function editAmenity(theAmenity) {
        setSelectedAmenity(theAmenity);
        setTimeLimit(theAmenity.timeLimit);
        setValue(theAmenity.name);
        setVisible(theAmenity.visible);
        setVaccine(theAmenity.vaccine);
        setAmenityOpen(true);
    }
    return (react_1.default.createElement(ListItem_1.default, null,
        react_1.default.createElement(ListItemText_1.default, { primary: primary, secondary: secondary }),
        react_1.default.createElement(ListItemSecondaryAction_1.default, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "edit", onClick: function () { editAmenity(amenity); }, size: "large" },
                    react_1.default.createElement(Edit_1.default, null)),
                react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "delete", onClick: function () { deleteAmenity(amenity); }, size: "large" },
                    react_1.default.createElement(Delete_1.default, null))))));
}
exports.default = AmenityLI;
